// extracted by mini-css-extract-plugin
module.exports = {"landscapeWarning":"LandscapeWarning_landscapeWarning__1iYQh","flip":"LandscapeWarning_flip__U7HsI","bl":"LandscapeWarning_bl__3uETa","tr":"LandscapeWarning_tr__2irxJ"};